var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "senWord-statistics" },
    [
      _c("div", { staticClass: "staff-chat-supervise-search" }, [
        _c(
          "div",
          { staticClass: "serach-left" },
          [
            _c("el-date-picker", {
              staticStyle: { width: "240px", "margin-right": "10px" },
              attrs: {
                size: "mini",
                type: "daterange",
                editable: false,
                "value-format": "yyyy-MM-dd",
                "range-separator": "~",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "picker-options": _vm.pickerOptions,
                clearable: false
              },
              on: { change: _vm.selectTime },
              model: {
                value: _vm.searchSelectTime,
                callback: function($$v) {
                  _vm.searchSelectTime = $$v
                },
                expression: "searchSelectTime"
              }
            }),
            _c("el-input", {
              staticStyle: { width: "190px", "margin-right": "10px" },
              attrs: {
                size: "mini",
                "suffix-icon": "el-icon-search",
                placeholder: "敏感词",
                clearable: ""
              },
              on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
              model: {
                value: _vm.formInline.wordName,
                callback: function($$v) {
                  _vm.$set(_vm.formInline, "wordName", $$v)
                },
                expression: "formInline.wordName"
              }
            }),
            _c("el-input", {
              staticStyle: { width: "190px", "margin-right": "10px" },
              attrs: {
                size: "mini",
                "suffix-icon": "el-icon-search",
                placeholder: "姓名",
                clearable: ""
              },
              on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
              model: {
                value: _vm.formInline.userName,
                callback: function($$v) {
                  _vm.$set(_vm.formInline, "userName", $$v)
                },
                expression: "formInline.userName"
              }
            })
          ],
          1
        ),
        _vm.mgctjdcdj
          ? _c(
              "div",
              { staticClass: "serach-right" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.handleExport }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  ref: "cusChatTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: "calc(100vh - 238px)",
                    "empty-text": "暂无敏感词的违规情况"
                  },
                  on: { "row-click": _vm.handleclick }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "wordName",
                      label: "敏感词",
                      "min-width": "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "归属分类",
                      "min-width": "150"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.wordTypeName &&
                                    scope.row.wordTypeName != null
                                    ? scope.row.wordTypeName
                                    : "-"
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hitCount",
                      align: "center",
                      label: "出现次数",
                      "min-width": "80"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userCount",
                      align: "center",
                      label: "涉及员工数",
                      "min-width": "80"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "涉及员工明细",
                      "min-width": "250",
                      align: "center",
                      "show-overflow-tooltip": false
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "tag-wrap" },
                              [
                                _vm._l(scope.row.users, function(item, index) {
                                  return _c("span", { key: item.userId }, [
                                    _c("span", [_vm._v(_vm._s(item.userName))]),
                                    index != scope.row.users.length - 1
                                      ? _c("span", [_vm._v("、")])
                                      : _vm._e()
                                  ])
                                }),
                                scope.row.showMoreFlag
                                  ? _c("span", [_c("span", [_vm._v("...")])])
                                  : _vm._e(),
                                _c(
                                  "span",
                                  {
                                    staticClass: "more-users",
                                    on: {
                                      click: function($event) {
                                        return _vm.toDetail(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v(" 明细")]
                                )
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c("senDetail", { ref: "senDetail" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }